<template>
  <a @click="$emit('click')">
    <slot></slot>
  </a>
</template>

<script setup></script>

<style lang="scss" scoped>
$sel: '.btn';
#{$sel} {
  font-family: 'sfPro';
  font-weight: 600;
  font-size: 0.875rem;
  padding: 0.4rem 1.2rem;
  border: none;
  text-transform: capitalize;
  cursor: pointer;
  display: inline-block;
  letter-spacing: 0.1rem;
  text-align: center;
  border-radius: 0.2rem;
  &:not(:first-of-type) {
    margin-left: 0.6rem;
  }
  &:active,
  &:focus {
    outline: none;
    box-shadow: none;
  }
  &#{$sel}-theme-primary {
    background-color: $theme-primary;
    color: #fff;
    transition: all 0.2s ease-out;
    &:hover {
      background-color: lighten($color: $theme-primary, $amount: 5%);
    }
  }
  &#{$sel}-theme-secondary {
    background-color: #fff;
  }
  &#{$sel}-theme-danger {
    background-color: #ff5c5c;
    color: #fff;
  }
  &#{$sel}-theme-info {
    background-color: #309ef2;
    color: #fff;
  }
  &#{$sel}-theme-current {
    background-color: #ff5c5c;
    color: #fff;
  }
  &#{$sel}-theme-transparent {
    background-color: transparent;
  }
  &#{$sel}-theme-yellow {
    background-color: #ffff66;
    color: #1d1f20;
  }
}
</style>
